import { PDFArray, PDFDict, type PDFDocument, PDFRef, PDFStream, PDFRawStream, type PDFObject } from "pdf-lib";

/**
 * What each page costs in the file as it stands: the sizes of the streams reachable from it (content, pictures, fonts),
 * with anything shared between pages split between them. Lets the compressor see which pages are worth turning into pictures.
 */
export function pageFootprints(doc: PDFDocument): number[] {
  const ctx = doc.context;
  const pages = doc.getPages();
  const reach: Set<string>[] = [];
  const sizes = new Map<string, number>();
  const uses = new Map<string, number>();
  const SKIP = new Set(["Parent", "P", "Prev", "Next", "First", "Last", "Dest", "D"]);
  for (const page of pages) {
    const seen = new Set<string>();
    const stack: PDFObject[] = [page.node];
    while (stack.length) {
      const o = stack.pop()!;
      let target: PDFObject | undefined = o;
      if (o instanceof PDFRef) {
        const key = o.toString();
        if (seen.has(key)) continue;
        seen.add(key);
        target = ctx.lookup(o);
        if (target instanceof PDFStream && !sizes.has(key)) sizes.set(key, target instanceof PDFRawStream ? target.contents.length : target.getContentsSize());
      }
      if (!target) continue;
      if (target instanceof PDFDict) {
        for (const [k, v] of target.entries()) if (!SKIP.has(k.decodeText())) stack.push(v);
      } else if (target instanceof PDFStream) {
        for (const [k, v] of target.dict.entries()) if (!SKIP.has(k.decodeText())) stack.push(v);
      } else if (target instanceof PDFArray) {
        for (let i = 0; i < target.size(); i++) stack.push(target.get(i));
      }
    }
    reach.push(seen);
    seen.forEach((k) => uses.set(k, (uses.get(k) ?? 0) + 1));
  }
  return reach.map((seen) => {
    let n = 400; // the page's own dictionary and its entry in the page tree
    seen.forEach((k) => { const sz = sizes.get(k); if (sz) n += sz / (uses.get(k) ?? 1); });
    return Math.round(n);
  });
}
